import * as Sentry from '@sentry/react';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;

const getEnvironmentConfig = () => {
  // You can expand this based on your deployment setup
  const env = process.env.REACT_APP_ENVIRONMENT || 'development';

  if (env === 'prod') {
    return {
      environment: 'production',
      tracesSampleRate: 0.1,
      debug: false,
    };
  }

  if (env === 'staging') {
    return {
      environment: 'staging',
      tracesSampleRate: 0.5,
      debug: true,
    };
  }

  return {
    environment: 'development',
    tracesSampleRate: 1.0,
    debug: true,
  };
};

export const initializeSentry = () => {
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found. Error tracking is disabled.');
    return;
  }

  const envConfig = getEnvironmentConfig();

  Sentry.init({
    dsn: SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE || undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    replaysOnErrorSampleRate: 1.0,
    beforeSend(event, hint) {
      // Filter out Android WebView noise from Facebook in-app browser
      const message = event.exception?.values?.[0]?.value || '';
      if (message.includes('Java object is gone')) {
        return null;
      }

      // Attach user email from session if Sentry.setUser hasn't been called yet
      if (!event.user?.email) {
        const email = sessionStorage.getItem('user');
        if (email && email !== 'undefined') {
          event.user = { ...event.user, email };
        }
      }

      // Enrich Axios network errors with request details
      const error = hint?.originalException;
      if (error?.isAxiosError) {
        event.tags = {
          ...event.tags,
          axios_url: error.config?.url,
          axios_method: error.config?.method?.toUpperCase(),
          axios_error_code: error.code,
        };
        event.extra = {
          ...event.extra,
          request_url: error.config?.url,
          request_method: error.config?.method?.toUpperCase(),
          request_data: error.config?.data,
          response_status: error.response?.status,
          response_data: error.response?.data,
          error_code: error.code,
        };
      }

      return event;
    },
    // Apply environment-specific settings
    ...envConfig,
  });
};

// Optional: Add custom context information
export const setUserContext = (user) => {
  Sentry.setUser({
    email: user.email,
  });
};
